import { render, staticRenderFns } from "./ManageSign.vue?vue&type=template&id=af63b31e"
import script from "./ManageSign.vue?vue&type=script&lang=js"
export * from "./ManageSign.vue?vue&type=script&lang=js"
import style0 from "./ManageSign.vue?vue&type=style&index=0&id=af63b31e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports